export default function isCardExpirationSameYear(cardExpiration) {
  const currentYear = new Date().getFullYear();
  const cardIsSameYear = cardExpiration.split('-')[0] === currentYear.toString();
  const cardIsInPast =
    cardExpiration.split('-')[0] < currentYear.toString() ||
    (cardExpiration.split('-')[0] === currentYear.toString() &&
      cardExpiration.split('-')[1] <= new Date().getMonth() + 1);
  const cardWarning = cardIsSameYear && !cardIsInPast;
  return cardWarning;
}
